import { render, staticRenderFns } from "./ErrorWrapper.vue?vue&type=template&id=4baa8dd5&"
import script from "./ErrorWrapper.ts?vue&type=script&lang=ts&"
export * from "./ErrorWrapper.ts?vue&type=script&lang=ts&"
import style0 from "./ErrorWrapper.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports